import { useEffect, useState, useContext } from 'react';
import { Link, NavLink } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';

import { getNoticeList } from '../modules/NetworkFunction';
import AuthContext from '../contexts/AuthContext';

const MyPageNavBar = () => {
  const { auth } = useContext(AuthContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isNew, setIsNew] = useState(false);

  const curPath = window.location.pathname;

  useEffect(() => {
    getNoticeList(
      { page: 1 },
      (data) => {
        if (data.length > 0) {
          const lastNoticeCreateDate = data[data.length - 1].createDate;
          const diff = moment().diff(lastNoticeCreateDate, 'days');
          if (diff < 7) {
            setIsNew(true);
          }
        }
      },
      () => {},
      (v) => {
        console.log(v);
      },
      auth
    );
  }, [auth]);

  const pathCheck = (keyword) => {
    return curPath.indexOf(keyword); // keyword가 curPath에 없으면 -1 반환
  };

  useEffect(() => {
    if (
      pathCheck('setting') !== -1 &&
      pathCheck('content-posting-setting') === -1
    ) {
      setActiveIndex(0);
    } else if (
      pathCheck('contents-making') !== -1 ||
      pathCheck('contents-posting-management') !== -1 ||
      pathCheck('contents-management') !== -1 ||
      pathCheck('content-design-management') !== -1 ||
      pathCheck('contents-list') !== -1 ||
      pathCheck('published-contents') !== -1 ||
      pathCheck('content-posting-setting') !== -1
    ) {
      setActiveIndex(1);
    } else if (
      pathCheck('statistics') !== -1 ||
      pathCheck('popular-products') !== -1 ||
      pathCheck('purchase-induce-rate') !== -1
    ) {
      setActiveIndex(2);
    } else if (pathCheck('service-info') !== -1) {
      setActiveIndex(3);
    } else if (pathCheck('payment') !== -1) {
      setActiveIndex(4);
    } else if (pathCheck('notice') !== -1) {
      setActiveIndex(5);
    }
  }, [curPath]);

  return (
    <Container>
      <TalkIconContainer>
        <TalkIcon
          href="http://pf.kakao.com/_XKJEn"
          target="_blank"
          rel="noreferrer"
        >
          <img src={'../icons/ic-talk.png'} alt="톡 상담 아이콘" />
        </TalkIcon>
        <TalkLabel>톡 상담</TalkLabel>
      </TalkIconContainer>
      <p style={{ fontSize: 30, color: '#FFB600', marginBottom: 15 }}>
        MY PAGE
      </p>
      <div
        className={`flexrowcenter ${activeIndex === 0 ? 'active' : ''}`}
        onClick={() => {
          setActiveIndex(0);
        }}
      >
        <div
          className={
            activeIndex === 0 ? 'mypageleftbar-checked' : 'mypageleftbar'
          }
        />

        <p
          className={activeIndex === 0 ? 'mypageleftp-clicked' : 'mypageleftp'}
        >
          기본 설정
        </p>
      </div>
      <div className={`submenu ${activeIndex === 0 ? 'active' : ''}`}>
        <NavLink
          to="/mypage/setting"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          기본 설정
        </NavLink>
        <NavLink
          to="/mypage/info"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          회원 정보
        </NavLink>
        <NavLink
          to="/mypage/pw-change"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          비밀번호 수정
        </NavLink>
        <NavLink
          to="/mypage/shop-link"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          쇼핑몰 관리
        </NavLink>
      </div>

      <div
        className={`flexrowcenter ${activeIndex === 1 ? 'active' : ''}`}
        onClick={() => {
          setActiveIndex(1);
        }}
      >
        <div
          className={
            activeIndex === 1 ? 'mypageleftbar-checked' : 'mypageleftbar'
          }
        />
        <p
          className={activeIndex === 1 ? 'mypageleftp-clicked' : 'mypageleftp'}
          onClick={() => {
            setActiveIndex(1);
          }}
        >
          콘텐츠 관리
        </p>
      </div>
      <div className={`submenu ${activeIndex === 1 ? 'active' : ''}`}>
        <NavLink
          to="/mypage/contents-making"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          콘텐츠 만들기
        </NavLink>

        <NavLink
          to="/mypage/contents-posting-management"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          게시 및 플러그인 관리
        </NavLink>

        <NavLink
          to="/mypage/contents-list"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          내 콘텐츠 목록
        </NavLink>
      </div>

      {/* 통계정보 => (MyPageStatistics : 상품순위, MyPageStatisticsByTime : 시간대 별 상품순위, ViewContentsStatistics : 콘텐츠 조회, PopularContents : 콘텐츠 인기상품, PurchaseInduceRate : 구매 유도율) */}
      <div
        className={`flexrowcenter ${activeIndex === 2 ? 'active' : ''}`}
        onClick={() => {
          setActiveIndex(2);
        }}
      >
        <div
          className={
            activeIndex === 2 ? 'mypageleftbar-checked' : 'mypageleftbar'
          }
        />
        <p
          className={activeIndex === 2 ? 'mypageleftp-clicked' : 'mypageleftp'}
        >
          통계 정보
        </p>
      </div>

      <div className={`submenu ${activeIndex === 2 ? 'active' : ''}`}>
        <Link to="/mypage/statistics">
          {/* 상품순위 */}
          <p
            className={'mypageleftinnerp'}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setActiveIndex(2);
            }}
          >
            상품 통계
          </p>
        </Link>

        <NavLink
          to="/mypage/statistics"
          className={(isActive) =>
            'mypageleftinnerinnerp' + (isActive ? '-clicked' : '')
          }
        >
          ∙ 상품별 조회 순위
        </NavLink>

        <NavLink
          to="/mypage/statistics-by-time"
          className={(isActive) =>
            'mypageleftinnerinnerp' + (isActive ? '-clicked' : '')
          }
        >
          ∙ 시간대별 조회 순위
        </NavLink>

        <Link to="/mypage/contents-statistics">
          {/* 콘텐츠 조회 */}
          <p
            className={'mypageleftinnerp'}
            onClick={() => {
              setActiveIndex(2);
            }}
          >
            영상 통계
          </p>
        </Link>

        <NavLink
          to="/mypage/contents-statistics"
          className={(isActive) =>
            'mypageleftinnerinnerp' + (isActive ? '-clicked' : '')
          }
        >
          ∙ 콘텐츠별 조회 순위
        </NavLink>

        <NavLink
          to="/mypage/popular-products"
          className={(isActive) =>
            'mypageleftinnerinnerp' + (isActive ? '-clicked' : '')
          }
        >
          ∙ 콘텐츠별 인기 상품
        </NavLink>

        <NavLink
          to="/mypage/purchase-induce-rate"
          className={(isActive) =>
            'mypageleftinnerp' + (isActive ? '-clicked' : '')
          }
        >
          구매 유도율
        </NavLink>
      </div>

      <NavLink
        to="/mypage/service-info"
        className={(isActive) =>
          'mypageleftp' + (isActive && activeIndex === 3 ? '-clicked' : '')
        }
      >
        <div
          className={'flexrowcenter'}
          onClick={() => {
            setActiveIndex(3);
          }}
        >
          <div
            className={
              activeIndex === 3 ? 'mypageleftbar-checked' : 'mypageleftbar'
            }
          />
          서비스 안내
        </div>
      </NavLink>

      <NavLink
        to="/mypage/payment"
        className={(isActive) =>
          'mypageleftp' +
          ((isActive && activeIndex === 4) || curPath.includes('payment')
            ? '-clicked'
            : '')
        }
      >
        <div
          className={'flexrowcenter'}
          onClick={() => {
            setActiveIndex(4);
          }}
        >
          <div
            className={
              activeIndex === 4 ? 'mypageleftbar-checked' : 'mypageleftbar'
            }
          />
          결제 관리
        </div>
      </NavLink>
      <NavLink
        to="/mypage/notice"
        className={(isActive) =>
          'mypageleftp' + (isActive && activeIndex === 5 ? '-clicked' : '')
        }
      >
        <div
          className={'flexrowcenter'}
          onClick={() => {
            setActiveIndex(5);
          }}
        >
          <div
            className={
              activeIndex === 5 ? 'mypageleftbar-checked' : 'mypageleftbar'
            }
          />
          공지사항
          <p
            style={{
              color: '#FF7A00',
              marginLeft: 15,
              fontSize: 13,
              fontWeight: 700,
            }}
          >
            {isNew ? 'NEW' : ''}
          </p>
        </div>
      </NavLink>
    </Container>
  );
};

export default MyPageNavBar;

const Container = styled.div`
  background-color: #fff;
  width: 230px;
  height: 810px;
  border-radius: 13px;
  margin-right: 20px;
  padding-left: 35px;
  padding-top: 15px;
  border: 0.5px solid #c4c4c4;
  position: relative;
  flex-shrink: 0;
`;

const TalkIconContainer = styled.div`
  position: absolute;
  left: -56px;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TalkLabel = styled.div`
  color: #848484;
  font-size: 10px;
`;

const TalkIcon = styled.a`
  margin-bottom: 5px;
  background-color: #fff;
  width: 36px;
  height: 36px;
  border: 0.5px solid #fee100;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
